import React from 'react';
import styles from './Dialog.module.scss';
import ButtonWithIcon from './ButtonWithIcon';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

export const Cypress_DATA = {
  dialog: 'base-dialog',
  overlay: 'base-dialog-overlay',
  title: 'base-dialog-title',
  description: 'base-dialog-description',
  acceptButton: 'base-dialog-accept',
  cancelButton: 'base-dialog-cancel',
};

type Props = {
  isOpen: boolean;
  title: string;
  description: string;
  acceptLabel?: string;
  cancelLabel?: string;
  onAccept: () => void;
  onCancel: () => void;
  dataCy?: string;
};

const Dialog = ({
  isOpen,
  title,
  description,
  acceptLabel = 'Ja',
  cancelLabel = 'Avbryt',
  onAccept,
  onCancel,
  dataCy,
}: Props) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div
      className={styles.overlay}
      onClick={handleOverlayClick}
      data-cy={Cypress_DATA.overlay}
    >
      <div className={styles.dialog} data-cy={dataCy ?? Cypress_DATA.dialog}>
        <h2 className={styles.title} data-cy={Cypress_DATA.title}>
          {title}
        </h2>
        <p className={styles.description} data-cy={Cypress_DATA.description}>
          {description}
        </p>
        <div className={styles.buttonContainer}>
          <div className={styles.buttonWrapper}>
            <ButtonWithIcon
              type="button"
              onClick={onCancel}
              label={cancelLabel}
              Icon={CancelOutlinedIcon}
              dataCy={Cypress_DATA.cancelButton}
            />
          </div>
          <div className={styles.buttonWrapper}>
            <ButtonWithIcon
              type="button"
              onClick={onAccept}
              label={acceptLabel}
              Icon={CheckCircleOutlineIcon}
              dataCy={Cypress_DATA.acceptButton}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dialog;
